import { render } from "./mobile-header.vue?vue&type=template&id=c2f87620&scoped=true"
import script from "./mobile-header.vue?vue&type=script&lang=js"
export * from "./mobile-header.vue?vue&type=script&lang=js"

import "./mobile-header.vue?vue&type=style&index=0&id=c2f87620&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f87620"]])

export default __exports__